// Generated by purs version 0.14.3
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Error = require("../Data.Argonaut.Decode.Error/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_ByteString = require("../Data.ByteString/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Network_Ethereum_Core_BigNumber = require("../Network.Ethereum.Core.BigNumber/index.js");
var Node_Encoding = require("../Node.Encoding/index.js");
var Simple_JSON = require("../Simple.JSON/index.js");
var Text_Parsing_Parser_String = require("../Text.Parsing.Parser.String/index.js");
var Pos = (function () {
    function Pos() {

    };
    Pos.value = new Pos();
    return Pos;
})();
var Neg = (function () {
    function Neg() {

    };
    Neg.value = new Neg();
    return Neg;
})();
var Signed = (function () {
    function Signed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Signed.create = function (value0) {
        return function (value1) {
            return new Signed(value0, value1);
        };
    };
    return Signed;
})();
var HexString = function (x) {
    return x;
};
var unHex = function (v) {
    return v;
};
var toUtf8 = function (hx) {
    var bs = function (hxstr) {
        return Data_Maybe.fromJust()(Data_ByteString.fromString(hxstr)(Node_Encoding.Hex.value));
    };
    return Data_Function.flip(Data_ByteString.toString)(Node_Encoding.UTF8.value)(bs(unHex(hx)));
};
var toByteString = function (hx) {
    return Data_Maybe.fromJust()(Data_ByteString.fromString(unHex(hx))(Node_Encoding.Hex.value));
};
var toAscii = function (hx) {
    return Data_Function.flip(Data_ByteString.toString)(Node_Encoding.ASCII.value)(Data_Maybe.fromJust()(Data_ByteString.fromString(unHex(hx))(Node_Encoding.Hex.value)));
};
var takeHex = function (n) {
    return function (v) {
        return HexString(Data_String_CodePoints.take(n)(v));
    };
};
var stringLikeHexString = Text_Parsing_Parser_String.stringLikeString;
var showSigned = function (dictShow) {
    return new Data_Show.Show(function (v) {
        var s$prime = (function () {
            if (v.value0 instanceof Pos) {
                return "";
            };
            if (v.value0 instanceof Neg) {
                return "-";
            };
            throw new Error("Failed pattern match at Network.Ethereum.Core.HexString (line 64, column 12 - line 66, column 19): " + [ v.value0.constructor.name ]);
        })();
        return s$prime + Data_Show.show(dictShow)(v.value1);
    });
};
var showHexString = new Data_Show.Show(function (v) {
    return "0x" + v;
});
var semigpStringEq = Data_Semigroup.semigroupString;
var nullWord = "0000000000000000000000000000000000000000000000000000000000000000";
var monoidStringEq = Data_Monoid.monoidString;
var mkHexString = function (str) {
    if (Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(Data_String_CodePoints.length(str))(2) !== 0) {
        return Data_Maybe.Nothing.value;
    };
    if (Data_Boolean.otherwise) {
        var hexAlph = Data_Set.fromFoldable(Data_Foldable.foldableArray)(Data_Ord.ordChar)(Data_String_CodeUnits.toCharArray("0123456789abcdefABCDEF"));
        var go = function ($copy_s) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(s) {
                var v = Data_Array.uncons(s);
                if (v instanceof Data_Maybe.Nothing) {
                    $tco_done = true;
                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Unit.unit);
                };
                if (v instanceof Data_Maybe.Just) {
                    var $41 = Data_Set.member(Data_Ord.ordChar)(v.value0.head)(hexAlph);
                    if ($41) {
                        $copy_s = v.value0.tail;
                        return;
                    };
                    $tco_done = true;
                    return Data_Maybe.Nothing.value;
                };
                throw new Error("Failed pattern match at Network.Ethereum.Core.HexString (line 143, column 16 - line 148, column 27): " + [ v.constructor.name ]);
            };
            while (!$tco_done) {
                $tco_result = $tco_loop($copy_s);
            };
            return $tco_result;
        };
        return Data_Functor.map(Data_Maybe.functorMaybe)(HexString)((function () {
            var v = Data_String_CodeUnits.stripPrefix("0x")(str);
            if (v instanceof Data_Maybe.Nothing) {
                var $46 = Data_Maybe.isJust(go(Data_String_CodeUnits.toCharArray(str)));
                if ($46) {
                    return Data_Maybe.Just.create(Data_String_Common.toLower(str));
                };
                return Data_Maybe.Nothing.value;
            };
            if (v instanceof Data_Maybe.Just) {
                var $47 = Data_Maybe.isJust(go(Data_String_CodeUnits.toCharArray(v.value0)));
                if ($47) {
                    return Data_Maybe.Just.create(Data_String_Common.toLower(v.value0));
                };
                return Data_Maybe.Nothing.value;
            };
            throw new Error("Failed pattern match at Network.Ethereum.Core.HexString (line 134, column 7 - line 140, column 35): " + [ v.constructor.name ]);
        })());
    };
    throw new Error("Failed pattern match at Network.Ethereum.Core.HexString (line 130, column 1 - line 130, column 41): " + [ str.constructor.name ]);
};
var toSignedHexString = function (bn) {
    var sgn = (function () {
        var $49 = Data_Ord.lessThan(Network_Ethereum_Core_BigNumber.ordBigNumber)(bn)(Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber));
        if ($49) {
            return Neg.value;
        };
        return Pos.value;
    })();
    var rawStr = Network_Ethereum_Core_BigNumber.toString(Data_Int.hexadecimal)(bn);
    var str = Data_Maybe.fromJust()(mkHexString((function () {
        var $50 = Data_Int.even(Data_String_CodePoints.length(rawStr));
        if ($50) {
            return rawStr;
        };
        return "0" + rawStr;
    })()));
    return new Signed(sgn, str);
};
var toHexString = function (bn) {
    var v = toSignedHexString(bn);
    return v.value1;
};
var mapSigned = new Data_Functor.Functor(function (f) {
    return function (v) {
        return new Signed(v.value0, f(v.value1));
    };
});
var hexStringOrd = Data_Ord.ordString;
var hexStringEq = new Data_Eq.Eq(function (v) {
    return function (v1) {
        return Data_String_Common.toLower(v) === Data_String_Common.toLower(v1);
    };
});
var hexLength = function (v) {
    return Data_String_CodePoints.length(v);
};
var getPadLength = function (len) {
    var n = Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(len)(64);
    var $61 = n === 0;
    if ($61) {
        return 0;
    };
    return 64 - n | 0;
};
var fromUtf8 = function (s) {
    return Data_Maybe.fromJust()((function () {
        var s$prime = (Data_String_Common.split("\x00")(s))[0];
        return Control_Bind.bind(Data_Maybe.bindMaybe)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_ByteString.fromString(s$prime)(Node_Encoding.UTF8.value))((function () {
            var $82 = Control_Applicative.pure(Data_Maybe.applicativeMaybe);
            var $83 = Data_Function.flip(Data_ByteString.toString)(Node_Encoding.Hex.value);
            return function ($84) {
                return $82($83($84));
            };
        })()))(mkHexString);
    })());
};
var fromByteString = function (bs) {
    return Data_Maybe.fromJust()(mkHexString(Data_ByteString.toString(bs)(Node_Encoding.Hex.value)));
};
var fromAscii = function (s) {
    return Data_Maybe.fromJust()(Control_Bind.bind(Data_Maybe.bindMaybe)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_ByteString.fromString(s)(Node_Encoding.ASCII.value))((function () {
        var $85 = Control_Applicative.pure(Data_Maybe.applicativeMaybe);
        var $86 = Data_Function.flip(Data_ByteString.toString)(Node_Encoding.Hex.value);
        return function ($87) {
            return $85($86($87));
        };
    })()))(mkHexString));
};
var eqSign = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Pos && y instanceof Pos) {
            return true;
        };
        if (x instanceof Neg && y instanceof Neg) {
            return true;
        };
        return false;
    };
});
var eqSigned = function (dictEq) {
    return new Data_Eq.Eq(function (v) {
        return function (v1) {
            return Data_Eq.eq(eqSign)(v.value0)(v1.value0) && Data_Eq.eq(dictEq)(v.value1)(v1.value1);
        };
    });
};
var padLeftSigned = function (v) {
    var sgn = (function () {
        var $71 = Data_Eq.eq(eqSign)(v.value0)(Pos.value);
        if ($71) {
            return "0";
        };
        return "f";
    })();
    var padLength = getPadLength(hexLength(v.value1));
    var padding = Data_Maybe.fromJust()(mkHexString(Data_String_CodeUnits.fromCharArray(Data_Array.replicate(padLength)(sgn))));
    return Data_Semigroup.append(semigpStringEq)(padding)(v.value1);
};
var padRightSigned = function (v) {
    var sgn = (function () {
        var $75 = Data_Eq.eq(eqSign)(v.value0)(Pos.value);
        if ($75) {
            return "0";
        };
        return "f";
    })();
    var padLength = getPadLength(hexLength(v.value1));
    var padding = Data_Maybe.fromJust()(mkHexString(Data_String_CodeUnits.fromCharArray(Data_Array.replicate(padLength)(sgn))));
    return Data_Semigroup.append(semigpStringEq)(v.value1)(padding);
};
var dropHex = function (n) {
    return function (v) {
        return HexString(Data_String_CodePoints.drop(n)(v));
    };
};
var asSigned = function (a) {
    return new Signed(Pos.value, a);
};
var padLeft = function ($88) {
    return padLeftSigned(asSigned($88));
};
var padRight = function ($89) {
    return padRightSigned(asSigned($89));
};
var _encode = (function () {
    var $90 = Data_Semigroup.append(Data_Semigroup.semigroupString)("0x");
    return function ($91) {
        return $90(unHex($91));
    };
})();
var encodeHexString = new Foreign_Generic_Class.Encode((function () {
    var $92 = Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
    return function ($93) {
        return $92(_encode($93));
    };
})());
var writeFHexString = new Simple_JSON.WriteForeign(Foreign_Generic_Class.encode(encodeHexString));
var encodeJsonHexString = new Data_Argonaut_Encode_Class.EncodeJson((function () {
    var $94 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJString);
    return function ($95) {
        return $94(_encode($95));
    };
})());
var _decode = function (str) {
    var v = mkHexString(str);
    if (v instanceof Data_Maybe.Just) {
        return new Data_Either.Right(v.value0);
    };
    if (v instanceof Data_Maybe.Nothing) {
        return Data_Either.Left.create("Failed to parse as HexString: " + str);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Core.HexString (line 101, column 15 - line 103, column 60): " + [ v.constructor.name ]);
};
var decodeHexString = new Foreign_Generic_Class.Decode(function (s) {
    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)(s))(function (str) {
        return Data_Either.either((function () {
            var $96 = Foreign.fail(Data_Identity.monadIdentity);
            return function ($97) {
                return $96(Foreign.ForeignError.create($97));
            };
        })())(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity)))(_decode(str));
    });
});
var readFHexString = new Simple_JSON.ReadForeign(Foreign_Generic_Class.decode(decodeHexString));
var decodeJsonHexString = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonString)(json))(function (str) {
        return Data_Either.either(Data_Function["const"](Data_Either.Left.create(new Data_Argonaut_Decode_Error.UnexpectedValue(json))))(Data_Either.Right.create)(_decode(str));
    });
});
module.exports = {
    Pos: Pos,
    Neg: Neg,
    Signed: Signed,
    asSigned: asSigned,
    mkHexString: mkHexString,
    unHex: unHex,
    hexLength: hexLength,
    dropHex: dropHex,
    takeHex: takeHex,
    nullWord: nullWord,
    getPadLength: getPadLength,
    padLeftSigned: padLeftSigned,
    padLeft: padLeft,
    padRightSigned: padRightSigned,
    padRight: padRight,
    toUtf8: toUtf8,
    fromUtf8: fromUtf8,
    toAscii: toAscii,
    fromAscii: fromAscii,
    toSignedHexString: toSignedHexString,
    toHexString: toHexString,
    toByteString: toByteString,
    fromByteString: fromByteString,
    eqSign: eqSign,
    showSigned: showSigned,
    eqSigned: eqSigned,
    mapSigned: mapSigned,
    showHexString: showHexString,
    hexStringEq: hexStringEq,
    hexStringOrd: hexStringOrd,
    semigpStringEq: semigpStringEq,
    monoidStringEq: monoidStringEq,
    stringLikeHexString: stringLikeHexString,
    decodeHexString: decodeHexString,
    readFHexString: readFHexString,
    writeFHexString: writeFHexString,
    encodeHexString: encodeHexString,
    decodeJsonHexString: decodeJsonHexString,
    encodeJsonHexString: encodeJsonHexString,
    toBigNumber: $foreign.toBigNumber,
    toBigNumberFromSignedHexString: $foreign.toBigNumberFromSignedHexString
};
